import React from 'react';
import toast from 'react-hot-toast';
import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography
} from '@mui/material';

import EventNoteOutlinedIcon from '@mui/icons-material/EventNoteOutlined';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import { useParameterizedQuery } from 'react-fetching-library';
import { getClientScheduleDocument } from '../../../services/request';

export const ScheduleCard = ({ orderData, purchaserData }) => {
  const { query, loading } = useParameterizedQuery(getClientScheduleDocument);


  const handleDownloadSchedule = async () => {
    const { payload, error, loading } = await query(purchaserData.id, { order_id: orderData.id });
    if (!error && !loading) {

      const url = window.URL.createObjectURL(payload);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = url;
      a.download = 'Harmonogram Zielone Szkoły.pdf';
      a.click();
      window.URL.revokeObjectURL(url);

    } else {
      toast.error('Nie udało się pobrać pliku');
    }
  };

  return (
    <Card
      sx={{
        borderRadius: 4,
        boxShadow: theme => theme.shadows[2]
      }}
    >
      <CardContent sx={{ p: 5 }}>
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          mb={4}
        >
          <Box
            sx={{
              width: 56,
              height: 56,
              borderRadius: 2,
              bgcolor: 'primary.lighter',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <EventNoteOutlinedIcon color="primary" />
          </Box>

          <Typography
            variant="h4"
            fontWeight={700}
          >
            Harmonogram pobytu
          </Typography>
        </Stack>

        <Typography
          color="text.secondary"
          sx={{ mb: 4 }}
        >
          Harmonogram zawiera szczegółowy plan pobytu,
          organizację zajęć oraz informacje dotyczące
          przebiegu wyjazdu.
        </Typography>

        <Button
          variant="contained"
          size="large"
          startIcon={<DownloadOutlinedIcon />}
          onClick={handleDownloadSchedule}
          disabled={loading}
        >
          Pobierz harmonogram
        </Button>
      </CardContent>
    </Card>
  );
};
